

















import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeaderSub from "@/components/main-header-sub.vue";
import NavLeftSub from "@/components/nav-left-sub.vue";
import Zhuyuan from "@/components/duijie/zhuyuan/zhuyuan.vue";
@Component({
  components: {
    NavLeftSub,
    MainHeaderSub,
    Zhuyuan,
  },
})
export default class Name extends Vue {
  private get patient() {
    return this.$store.state.patient;
  }
}
